module.exports = __webpack_public_path__ + "img/download_transactions_auto.0f1d580d.svg";